import { useState, type FormEvent } from 'react';
import { ShopError, api } from '../api';
import { usePageMeta } from '../seo';

/**
 * Kontaktní formulář.
 *
 * Odešle zprávu do administrace (fronta k vyřízení). Bez přihlášení, s brzdou
 * proti spamu na serveru. Potvrzení i chyby ukazuje na místě.
 */
export function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');
  const [message, setMessage] = useState('');

  usePageMeta({
    title: 'Kontakt | Super Krmivo',
    description: 'Napište nám — dotazy k objednávce, zboží nebo čemukoli dalšímu.',
  });

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (status === 'sending') return;
    if (name.trim() === '' || email.trim() === '' || body.trim() === '') {
      setStatus('error');
      setMessage('Vyplň prosím jméno, e-mail i zprávu.');
      return;
    }

    setStatus('sending');
    try {
      await api.submitContact({
        name: name.trim(),
        email: email.trim(),
        ...(subject.trim() === '' ? {} : { subject: subject.trim() }),
        body: body.trim(),
      });
      setStatus('done');
      setMessage('Děkujeme! Zprávu jsme dostali a co nejdřív se ozveme.');
    } catch (error) {
      setStatus('error');
      setMessage(
        error instanceof ShopError ? error.message : 'Odeslání se nezdařilo. Zkus to prosím za chvíli.',
      );
    }
  }

  if (status === 'done') {
    return (
      <article className="content-page">
        <h1>Kontakt</h1>
        <p className="contact-done" role="status">
          {message}
        </p>
      </article>
    );
  }

  return (
    <article className="content-page">
      <h1>Kontakt</h1>
      <p className="muted">Napište nám — dotazy k objednávce, zboží nebo čemukoli dalšímu.</p>

      <form className="contact-form" onSubmit={submit} noValidate>
        <label className="field">
          <span>Jméno</span>
          <input value={name} onChange={(event) => setName(event.target.value)} maxLength={120} />
        </label>
        <label className="field">
          <span>E-mail</span>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            maxLength={320}
            autoComplete="email"
          />
        </label>
        <label className="field">
          <span>Předmět (nepovinné)</span>
          <input value={subject} onChange={(event) => setSubject(event.target.value)} maxLength={200} />
        </label>
        <label className="field">
          <span>Zpráva</span>
          <textarea
            value={body}
            onChange={(event) => setBody(event.target.value)}
            rows={6}
            maxLength={5000}
          />
        </label>

        {status === 'error' && <p className="field-error">{message}</p>}

        <button type="submit" className="button primary" disabled={status === 'sending'}>
          {status === 'sending' ? 'Odesílám…' : 'Odeslat zprávu'}
        </button>
      </form>
    </article>
  );
}
